// eslint-disable-next-line import/no-cycle
import { apiRequest } from './apiClient';

// eslint-disable-next-line import/prefer-default-export
export async function dismissProductTour(): Promise<void> {
    await apiRequest('/api/account/product-tour/dismiss', 'POST');
}
